import ContactPhoneBox from './ContactPhoneBox';
import ContactMailBox from './ContactMailBox';
import ContactWebsiteBox from './ContactWebsiteBox';
import ContactScheduleBox from './ContactScheduleBox';
import ContactBrochureBox from './ContactBrochureBox';

export {
  ContactPhoneBox,
  ContactMailBox,
  ContactWebsiteBox,
  ContactScheduleBox,
  ContactBrochureBox
};

export default {};
